import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { BulkSms } from '../../pages';
import { BulkSmsController, CustomerController, VendorController } from '../../controllers';
import { appStore, customerStore, useStores, bulkSmsStore } from '../../stores';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { toJS } from 'mobx';

const BulkSmsContainer = () => {
	const [composeSide, setComposeSide] = useState(false);
	const [msgView, setMsgView] = useState("Sent Messages");
	const [msgFilterItem, setMsgFilterItem] = useState("SENT");
	const [schedule, setSchedule] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loading2, setLoading2] = useState(false);
	const [btnClicked, setBtnClicked] = useState("");
	const [otp, setOtp] = useState('');
	const [sendPayload, setSendPayload] = useState({});
	const [draftId, setDraftId] = useState("");
	const [editMessage, setEditMessage] = useState(false);


	//for tags
	const [tags, setTags] = useState([]);

	const {
		userStore,
		vendorStore: { vendors },
		customerStore: { customers, setSelectedCustomer },
	} = useStores();

	useEffect(() => {
		const setCustomers = async () => {
			setLoading2(true);
			await Promise.all([
				CustomerController.getCustomers(),
				CustomerController.getCustomersGroups(),
				BulkSmsController.getAllMessages(),
				BulkSmsController.getAllProspects(),
				VendorController.getVendors(),
			]);
			setLoading2(false);
		};
		setCustomers();
	}, [customerStore]);

	const showComposeSide = () => {
		setComposeSide(true)

	}
  const refresh = async ()=> {
	setLoading2(true);
			await Promise.all([
				CustomerController.getCustomers(),
				CustomerController.getCustomersGroups(),
				BulkSmsController.getAllMessages(),
				BulkSmsController.getAllProspects(),
				VendorController.getVendors(),
			]);
			setLoading2(false);
  }
	const closeComposeSide = () => {
		setComposeSide(false);
		setEditMessage(false);
		setTags([]);
	}

	const showScheduleMsgModal = () => {
		setSchedule(true)
	}

	const closeModal = () => {
		setSchedule(false);
		setBtnClicked("");
		setOtp("")

	}

	const goToEditMessage = (msg) =>{
		setComposeSide(true);
		setDraftId(msg._id)
		setEditMessage(true);
		setTags(msg.numbers);
	}

	const mobileToNameMap = customers.reduce((acc, { fullname, mobile }) => {
		acc[mobile] = fullname;
		return acc;
	}, {});

	const withNumArr = bulkSmsStore?.allMessages.map((obj) => {
		// iterate over each number in the numbers array
		const updatedNumbers = obj.numbers.map((num) => {
			// check if the number is present in the mobileToNameMap
			if (mobileToNameMap[num]) {
				return mobileToNameMap[num];
			}
			return num;
		});
		// create a new object with updated numbers array
		return { ...obj, numbers: updatedNumbers };
	});

	const allMsgs = withNumArr.map(obj => ({
		...obj,
		numbersAndNames: obj.numbers.join(', '),
		truncatedMsg: obj.message.slice(0, 90) + '...',
		truncatedNumbers: obj.numbers.join(', ').substring(0, 70) + (obj.numbers.join(', ').length > 70 ? '...' : '')
	}));

	const goToViewMsgs = (msg) => {
		bulkSmsStore.setSelectedMessage(msg);
		setMsgView("Single Message")
	}

	const goBackFromViewMsgs = () => {
		const selectedMessage = bulkSmsStore.selectedMessage

		if (selectedMessage.status === "SENT") {
			setMsgView("Sent Messages");
			setMsgFilterItem("SENT");
		}

		if (selectedMessage.status === "SCHEDULED") {
			setMsgView("Scheduled Messages");
			setMsgFilterItem("SCHEDULED");
		}

		if (selectedMessage.status === "DRAFT") {
			setMsgView("Drafts");
			setMsgFilterItem("DRAFT");
		}
	}

	const sendDraft = (id) => {
		setDraftId(id);
		setBtnClicked("sendDraft");
	}

	const openSendScheduledModal = (id) => {
		setDraftId(id);
		setBtnClicked("sendScheduled");
	}

	const sendScheduled = async() => {
		let id = draftId

		setLoading(true);
		const { status, errorMessage } = await BulkSmsController.overrideScheduleSend(id);
			if (status === constant.Success) {
				setLoading(false);
				MimaToastUtil.success({
					message: constant.Success,
				});
				closeModal();
				setMsgView("Sent Messages")
                setMsgFilterItem("SENT")
			} else {
				setLoading(false);
				return MimaToastUtil.error({
					message: errorMessage,
				});
			}
	}




	const onSubmitOtp = async (otp) => {
		let payload

		setLoading(true)

		if (btnClicked === "send") {
			payload = {
				...sendPayload,
				pin: otp,
			}
			const { status, errorMessage } = await BulkSmsController.sendBulkSms(payload);
			if (status === constant.Success) {
				setLoading(false);
				MimaToastUtil.success({
					message: constant.Success,
				});
				closeModal();
				closeComposeSide();
				setMsgView("Sent Messages");
                setMsgFilterItem("SENT");
				setTags([])
			} else {
				setLoading(false);
				return MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}

		if (btnClicked === "sendDraft") {
			payload = {
				pin: otp,
			}

			let id = draftId

			const { status, errorMessage } = await BulkSmsController.sendDraftSms(id, payload);
			if (status === constant.Success) {
				setLoading(false);
				MimaToastUtil.success({
					message: constant.Success,
				});
				closeModal();
                closeComposeSide();
				setMsgView("Sent Messages");
                setMsgFilterItem("SENT");
			} else {
				setLoading(false);
				return MimaToastUtil.error({
					message: errorMessage,
				});
			}
		}
	}

	return (
		<BulkSms
			composeSide={composeSide}
			showComposeSide={showComposeSide}
			msgView={msgView}
			setMsgView={setMsgView}
			showScheduleMsgModal={showScheduleMsgModal}
			schedule={schedule}
			closeModal={closeModal}
			loading={loading}
			customers={customers}
			vendors={vendors}
			tags={tags}
			setTags={setTags}
			setBtnClicked={setBtnClicked}
			btnClicked={btnClicked}
			otp={otp}
			setOtp={setOtp}
			onSubmitOtp={onSubmitOtp}
			allMsgs={allMsgs}
			msgFilterItem={msgFilterItem}
			setMsgFilterItem={setMsgFilterItem}
			goToViewMsgs={goToViewMsgs}
			sendDraft={sendDraft}
			loading2={loading2}
			refresh={refresh}
			closeComposeSide={closeComposeSide}
			goToEditMessage={goToEditMessage}
			editMessage={editMessage}
			sendPayload={sendPayload}
			setSendPayload={setSendPayload}
			openSendScheduledModal={openSendScheduledModal}
			sendScheduled={sendScheduled}
			goBackFromViewMsgs={goBackFromViewMsgs}
		/>
	);
};

export default observer(BulkSmsContainer);
